import React from 'react';

import { ErrorCard } from './cards/error-card';
import { JobCard } from './cards/job-card';
import { SavedJobCard } from './saved-cards/index';
import { type CardType } from './types';

type CardMapType = {
  [key in CardType]: React.ComponentType<any>;
};

const cardMap: CardMapType = {
  TakenJob: JobCard,
  AvailableJob: JobCard,
  Error: ErrorCard,
};

const savedCardMap: CardMapType = {
  TakenJob: SavedJobCard,
  AvailableJob: SavedJobCard,
  Error: ErrorCard,
};

export { cardMap, savedCardMap };
